import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home/HomeView'
import { isLoggedIn } from '@/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: 'Lordky记账', requiresAuth: true }
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import('../views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/register/index.vue'),
    meta: { title: '注册' }
  },
  {
    path: '/account',
    name: 'AccountPage',
    component: () => import('../views/account/index.vue'),
    meta: { title: '消费记录', requiresAuth: true }
  },
  {
    path: '/income',
    component: () => import('../views/incomeAmount/index.vue'),
    name: 'IncomeAmountPage',
    meta: { title: '收入记录', requiresAuth: true }
  },
  {
    path: '/incomeType',
    name: 'IncomeTypePage',
    component: () => import('../views/incomeType/index.vue'),
    meta: { title: '收入类型', requiresAuth: true }
  },
  {
    path: '/giftBook',
    name: 'GiftBook',
    component: () => import('../views/giftBook/index.vue'),
    meta: { title: '礼金簿', requiresAuth: true }
  },
  {
    path: '/giftBookDetail',
    name: 'GiftBookDetail',
    component: ()=>import('../views/giftBookDetail/index.vue'),
    meta: { title: '礼金簿明细', requiresAuth: true }
  },
  {
    path: '/costType',
    name: 'CostType',
    component: () => import('../views/costType/index.vue'),
    meta: { title: '消费类型', requiresAuth: true }
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  document.title = (to.meta && to.meta.title) ? to.meta.title : 'Lordky记账';

  const requiresAuth = Boolean(to.meta && to.meta.requiresAuth);
  if (requiresAuth && !isLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
    return;
  }

  if ((to.path === '/login' || to.path === '/register') && isLoggedIn()) {
    next({ path: '/' });
    return;
  }

  next();
});

export default router
